module.exports = __webpack_public_path__ + "img/cut-while3.22a5dbed.png";